var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.346 19.683l-7.114-7.092a.745.745 0 01-.18-.274A.914.914 0 017 12c0-.113.017-.218.052-.317a.731.731 0 01.18-.274l7.114-7.113c.197-.198.443-.296.738-.296.296 0 .55.106.76.317.211.21.317.457.317.738 0 .282-.106.528-.317.74L9.64 12l6.205 6.206a.99.99 0 01.296.729c0 .288-.106.538-.317.748a1.012 1.012 0 01-.739.317c-.281 0-.527-.105-.738-.317z",
    fill: "currentColor"
  })));
}
export default SvgChevronLeft;